export const PDF_CONTENT_TYPE = 'application/pdf';

export const ACCEPTED_CONTENT_TYPES = ['image/jpeg', 'image/png', PDF_CONTENT_TYPE];

export const FILE_TYPE_FILTERS = [
  { value: 'all', label: 'Todos' },
  { value: 'images', label: 'Imagens' },
  { value: 'documents', label: 'Documentos' },
];

// Prefers the contentType sent by the backend; falls back to the file extension
// for records saved before the field existed.
export const isPdf = (file) =>
  file?.contentType === PDF_CONTENT_TYPE || /\.pdf$/i.test(file?.fileName || '');

export const filterByFileType = (files, fileTypeFilter) => {
  if (fileTypeFilter === 'images') return files.filter((file) => !isPdf(file));
  if (fileTypeFilter === 'documents') return files.filter((file) => isPdf(file));
  return files;
};
